import { forwardRef, useImperativeHandle, useRef } from 'react';

import ContentEditor from '@sayyesschool/frontend/components/content-editor';

function EssayItem({ content }, ref) {
    const editorRef = useRef();

    useImperativeHandle(ref, () => ({
        get props() {
            return {
                content: editorRef.current?.getData()
            };
        }
    }));

    return (
        <ContentEditor
            ref={editorRef}
            content={content}
        />
    );
}

export default forwardRef(EssayItem);